const en = {
  common: {
    home: 'home',
    email: 'Email address',
    first_name: 'First name',
    last_name: 'Last name',
    password: 'Password',
    repeat_password: 'Repeat password',
    forgot_password: 'Forgot password?',
    new_password: 'New password',    
    old_password: 'Old password',
    change_password: 'Change password',
    cancel: 'Cancel',
    continue: 'Continue',
    success: 'Success!',
    or: 'or',
    back: 'Back',
    signoff: 'Signoff',
    edit: 'Edit',
    save: 'Save',
    delete_device: 'Delete Device',
    open_device: 'Open Device',
    page: 'Page',
    close: 'Close',
    not_authorized: 'Not Authorized',
    access_denied: 'You do not have permission to access this page.',
    oops: 'Oops!',
    no_access_message: 'It seems you are not authorized to view this resource. Please contact support if you believe this is a mistake.',
    return_home: 'Return to Home',
    next: 'Next',
    confirm_delete: 'Are you sure?',
    confirm_delete_message: 'Do you really want to delete this device? This process cannot be undone.',
    delete: 'Delete',
    loading: 'Loading...',
    search: 'Search by device name or type',
    search_user: 'Search by user or device',  
    elements_per_page: 'Elements per page', 
    copied: 'Copied to clipboard',
    copy_key: 'Copy Verification Key',
    reload: 'Reload',
    support: 'support',
    successfully_saved: 'Changes saved successfully!',

  },

  errors: {
    global: 'An error occurred.',
    unknown: 'An unknown error occurred.',
    too_many_attempts: 'Too many login attempts. Please try again in {seconds} seconds.',
    could_not_authenticate: 'User could not be authenticated',
    invalid_email: 'Invalid email address',
    no_setup_key: 'No setupKeys found in the response',
    
    adminCannotDeleteOwnAccount: "You cannot delete your own account.",

    authenticationCookieRequired: "Authentication cookie is required.",
    authenticationRequired: "Authentication is required.",
    authenticationRequiredForTopics: "Authentication is required to access these topics.",

    deviceAccessDenied: "You do not have access to this device.",
    deviceIdRequired: "Device ID is required.",
    deviceIdRequiredInUri: "Device ID is required in the request URL.",
    deviceInvalidIpAddress: "The device IP address is invalid.",
    deviceIpNotInAllowedRange: "The device IP address is not in the allowed range.",
    deviceNotFound: "Device not found.",
    deviceNoIpAddress: "The device has no IP address assigned.",
    deviceUnavailable: "The device is currently unavailable.",
    deviceUnreachable: "The device cannot be reached.",

    emailNotVerified: "Your email address is not verified.",
    email_not_verified: 'Your email address is not verified.',
    emailAlreadyExists : "An account with this email already exists.",
    
    fbSignedRequestEmpty: "Facebook signed request is empty.",
    fbSignedRequestInvalidBase64: "Facebook signed request contains invalid Base64 data.",
    fbSignedRequestInvalidPayload: "Facebook signed request payload is invalid.",
    fbSignedRequestMalformed: "Facebook signed request is malformed.",
    fbSignedRequestSignatureMismatch: "Facebook signed request signature mismatch.",

    fcmAccessTokenMissing: "FCM access token is missing.",
    fcmAuthFailed: "Authentication with Firebase Cloud Messaging failed.",
    fcmInvalidPrivateKey: "Invalid Firebase private key.",
    fcmJwtSigningFailed: "Failed to sign Firebase JWT.",

    handledStampNotFound: "Handled stamp not found.",

    headerInvalidType: "Invalid header type.",
    headerNotAllowed: "This header is not allowed.",
    headerValueTooLong: "Header value is too long.",

    httpMethodNotAllowed: "HTTP method not allowed.",

    idpUnexpectedError: "Unexpected error from identity provider.",
    internalError: "Internal server error.",

    invalidCredentials: "Invalid credentials.",
    invalidLogLevel: "Invalid log level.",
    invalidUserClass: "Invalid user class.",

    messageHandlerNoResult: "Message handler returned no result.",

    netbirdApiError: "NetBird API error.",
    netbirdClientRequestFailed: "NetBird client request failed.",
    netbirdEmbeddedGroupNotFound: "NetBird embedded group not found.",
    netbirdRequestFailed: "NetBird request failed.",

    oidcUserCreationFailed: "Failed to create user via OpenID Connect.",

    pathEmpty: "Path must not be empty.",
    pathInvalidStart: "Path has an invalid start.",
    pathTooLong: "Path is too long.",
    pathTraversalNotAllowed: "Path traversal is not allowed.",

    payloadTooLarge: "Payload is too large.",
    rateLimitExceeded: "Rate limit exceeded. Please try again later.",

    requestNotFoundInContext: "Request not found in context.",
    requestRequired: "Request is required.",

    sessionNotFound: "Session not found.",

    ssoEmailExists: "An account with this email already exists.",
    ssoMissingIdOrToken: "SSO ID or token is missing.",
    ssoMultipleUsersFound: "Multiple users found for this SSO account.",
    ssoUserIdNotFound: "SSO user ID not found.",

    storageEncodingFailed: "Failed to encode storage data.",
    storageRecordCorrupted: "Stored record is corrupted.",

    unauthorized: "You are not authorized to perform this action.",

    userDeleteForbidden: "You are not allowed to delete this user.",
    userIdParameterRequired: "User ID parameter is required.",
    userIdRequired: "User ID is required.",
    userNotFound: "User not found.",

    zitadelClientRequestFailed: "Zitadel client request failed.",
    zitadelRequestFailed: "Zitadel request failed."
  },

  verification: {
    invalid_verification_link: 'Invalid verification link.',
    success: 'Your email has been verified successfully.',
    failed: 'Could not be verified: {error}',
    invalid_link: 'Invalid link',
    verifying_account:'Verifying your account...',
    email_not_received: 'Email not recieved?',
    resend_email: 'Resend email',
    sending: 'Sending email',
    resend_email_failed:'Failed to resend verification email.',
    resend_email_email_success:'Verification email sent successfully!',
    email_not_found: 'Email not found',
    error_resending_email: 'Error resending email',
    email_resent:'The verification mail has been send again. If you did not receive any mail from us, please contact {support}.'
  },

  registration: {
    register: 'Register',
    register_now: 'Register now',
    name: 'Name',
    repeat_password: 'Repeat password',
    already_signed_up: 'Already signed up?',
    sign_up: 'Sign up',
    sign_up_subtitle: 'Create an account to manage your devices',
    sign_up_here: 'Sign up here',
    get_started: 'Get started',
    no_account_yet: 'No account yet?',
    log_in_here: 'Log in here',
    check_email: 'Please check your email inbox and confirm your email address.',
    password_changed: 'Password sucessfully changed',
    password_updated: 'Your password has been updated',
    recheck_email: 'You haven’t verified your email address yet. Please verify it to use the app.',
    confirm_email: 'Please confirm Email',
    didnt_receive_email: 'You didn\'t receive an email?',
    user_already_exists: 'User already exists',
    sign_up_error: 'An error occurred during sign-up.',
    check_credentials: 'Please check your credentials.',
    terms_and_conditions: 'I have read the {terms} and conditions and the {privacy} and agree to them.',
    terms: 'terms and conditions',
    privacy: 'privacy policy'
    
  },

  login: {
    login: 'Login',
    auth: 'auth',
    login_or_register: 'Login or Sign Up',
    sign_in: 'Sign in',
    sign_in_subtitle: 'Log in to manage your devices.',
    continue_with_email: 'Continue with email address',
    tell_us_email: 'Tell us the email address of your account',
    login_google: 'Login with Google',
    login_facebook: 'Login with Facebook',
    login_apple: 'Login with Apple',
    enter_the_code: 'Enter the code, we have sent you, here.',
    choose_new_password: 'Choose a new password and continue.',
    wrong_username_password: 'You have entered an invalid username or password',
    passwords_does_not_match: 'The passwords does not match',
    login_instructions: 'We’ve sent an email with instructions to reset your password. Please check your inbox.',
    sign_up: 'Sign Up with email address',
    sign_in_with_email: 'Sign In with Email',
  },

  terms: {
    terms_of_Service: 'Terms of Service',
    privacy_policy: 'Privacy Policy',
    imprint: 'Imprint',
    text: 'by continuing, you agree to our',
    support: 'Support',
  },

  start: {
    welcome: 'Welcome!',
    welcome_msg: 'Quickly and easily manage your energielenker devices. Stay in control, anytime and anywhere.',
    lets_start: 'Let\'s start',
  },

  menu: {
    settings: 'Settings',
    plans: 'Plans',
    home: 'Home',
    admin: 'Admin'
  },

  home: {
    title: 'Your devices',
    subtitle: 'Manage your devices',
    add_device: 'Connect device',
    no_devices: 'You haven’t setup any devices yet.',
    edit_device: 'Edit device',
    device_name: 'Device Name',
    device_created: 'Enbas created successfully!',
    copy_key: 'Copy the key and enter it into your device.',
    add_another_device: 'Add more Devices',
  },


  admin: {
    title: 'Administration',
    subtitle: 'View all users and their devices',
  },


  settings: {
    settings: 'Settings',
    profile: 'Profile',
    payment: 'Payment',
    notifications: 'Notifications',
    help: 'Help',
    payment_details: 'Payment Plan and bank details',
    notification_details: 'What notifications do you want to receive',
    profile_details: 'Name and contact details',
    help_details: 'Help, Contact and Terms of Service',
    subtitle: 'Name and contact details',
  },

  plans: {
    select_plan: 'Select your plan',
    subtitle: 'Individually tailored to your needs',
    annual_pricing: 'Annual Pricing',
    save_percentage: 'Save {percentage}%',
    free_version: 'Free Version',
    subscribed: 'Subscribed',
    per_month: 'per month',
    manage_devices: 'Manage your devices',
    global_access: 'Global access to devices',
    cloud_optimization: 'Cloud+ Optimization',
    enbas_plus: 'Enbas Plus',
    recommended: 'Recommended'
  },

  payments: {
    title: 'Payments and subscriptions',
    cancel_subscription: 'Cancel subscription',
    enbas_plus: 'Enbas Plus',
    active: 'Active',
    inactive: 'Inactive',
  },

  profile: {
    name: 'Name',
    email: 'E-Mail-Adress',
    edit_profile: 'Edit profile',
    notifications: 'Notifications',
    delete_profile: 'Delete profile',
    delete_profile_message: 'Do you really want to delete your account? This process cannot be undone.',
    type_delete_to_confirm: 'Please write "delete"',
    delete_error: 'An error occurred while deleting the profile. Please try again.',
    language: 'Language',    
    incorrect_old_password: 'The old password you entered is incorrect.',
    password: 'Password',
    change_password: 'Change password',
    current_password: 'Current password',
    edit_email: 'Edit Email Address',
    edit_name: 'Edit Name',
    edit_language: 'Edit Language',
    edit_password: 'Edit Password',
    edit_password_text: 'Enter your current password to change your E-mail address.',
  },

  help: {
    title: 'Help',
    terms_of_service: 'Terms of Service',
    privacy_policy: 'Privacy Policy',
    support: 'Support',
    imprint: 'Imprint',
    copyright: 'Copyright energielenker solutions GmbH',
  },

  device: {
    all_devices: 'All devices',
    lobas: 'Lobas',
    enbas: 'Enbas',
    device_name: 'Device Name',
    device_updated: 'Device updated successfully!',
    device_name_required: 'Device name is required',
    device_help_before: 'Enter the key in the interface of your device.',
    device_help_link: 'Here',
    device_help_after: 'you can find help on how to do this.',    
    choose_device:'Choose a Device Name and continue.',
    connect_device:'Connect Device',
    explanation: 'After you tap continue, you will receive an API key that you must enter in the administration interface of your device. Once this is done, the device will be verified, and you will see the device with the status connected in the app.',
    exit_device: 'Exit Device',
    view_mode: 'Currently in Enbas View Mode',
    currently_unavailable: 'Device is currently unavailable (pending or disconnected).',
    first_setup_key: 'First Setup Key',
    status_changed: "Device {deviceType} {deviceName} status changed from {previousStatus} to {newStatus}",   
    verification_short_key: 'Verification Short Key',    
    explanation_key:'You have already provided the key? It may take a while for the connection to be confirmed.',
    recheck_status: 'Recheck Status',
    device_disconnected: 'Device disconnected',
    device_disconnected_message: 'The connection to your device has been removed. To reconnect, please go to the device settings and enter a new key.',
    status: {
      warning: 'Your device is currently pending verification. This may take a few moments.',
      update: 'Verification pending. Please ensure you\'re using the latest version on your ENBAS.',
      error: 'Failed to establish a connection to the device.',
      info: 'The connection was removed in the device settings.'
    },
    pending: 'Pending',
    connected: 'Connected',
    disconnected: 'Disconnected',
    connection_lost: 'Connection lost',
    connection_failed: 'Update required',



  },

  steps: {
    new_device_title: '1. New Device',
    new_device_description: 'You add a new device in the app.',
    enter_key_title: '2. Enter Key',
    enter_key_description: 'You enter the key in your device settings.',
    ready_to_go_title: 'Done!',
    ready_to_go_description: 'You are ready to go.'
  },

  install_app: {
    install: 'Install our app:',
    open_safari: 'Open Safari,',
    tap: 'tap',
    share: 'Share',
    add_to_home: 'Add to Home Screen',
    better_exp: 'for a better user experience!',
    then: 'then',
  },
  
  optimize: {
    title: 'Want to maximize your device performance?',
    subtitle: 'Get the Full Power of Enbas by Adding an Optimization Plan',
    learn_more: 'Learn More',
    dismiss: 'Dismiss'
  },


  filter:{
    show_disconnected_devices: 'Show disconnected devices',
    show_connected_devices: 'Show connected devices',
    filter: 'Filter',
    remove_filters: 'Remove filters',

  },

  notifications: {
    deviceStatusChanged: "Device {deviceId} changed from {from} to {to}",
    status: {
      pending_connected: "Your {deviceType} {deviceName} is now successfully connected.",
      connected_disconnected: "Your {deviceType} {deviceName} has been disconnected.",
      disconnected_connected: "Your {deviceType} {deviceName} is connected again.",
      connected_connection_lost: "Your {deviceType} {deviceName} lost connection.",
      connection_lost_connected: "Your {deviceType} {deviceName} has reconnected successfully.",
      update_required_connected: "Your {deviceType} {deviceName} has been updated and is connected again.",
      update_required_disconnected: "Your {deviceType} {deviceName} has been disconnected and still needs an update.",
      connection_lost_disconnected: "Your {deviceType} {deviceName} is no longer reachable and has been disconnected.",
      pending: "Your {deviceType} {deviceName} is pending connection.",
      update_required: "Your {deviceType} {deviceName} requires an update.",
      fallback: "Status update for {deviceType} {deviceName}"
    }
  },

  password: {
    submission_errors: 'There were {errorsNum} errors with your submission',
    password_valid: 'Your submission meets all requirements.', 
     
    password_errors: {
      length: 'Your password must be at least 8 characters',
      uppercase: 'Your password must have at least 1 uppercase letter',
      lowercase: 'Your password must have at least 1 lowercase letter',
      number: 'Your password must have at least 1 number',
      specialChar: 'Your password must have at  least 1 special character',
      mismatch: 'Passwords do not match',
      max_length: 'Password is too long',
    }
  },

  form: {
    no_errors_in_form: 'Your form meets all requirements.',
    submission_errors: 'There were {errorsNum} errors with your submission',
    errors: {
      invalid_email: 'Invalid email address',
      first_name_short: 'First name is too short',
      last_name_short: 'Last name is too short',
      first_name_too_long: 'First name is too long',
      last_name_too_long: 'Last name is too long',
      email_too_long: 'Email is too long',
      email_required: 'Email address is missing',
    }
  },

  page_titles: {
    welcome: 'Welcome',
    signup_login: 'Sign Up or Login',
    sign_up: 'Sign Up',
    sign_in: 'Sign In',
    signup_success: 'Registration Successful',
    forgot_password: 'Forgot Password',
    reset_password: 'Reset Password',
    user_verify: 'Verify User',
    edit_password: 'Change Password',
    edit_name: 'Change Name',
    edit_email: 'Change Email',

    plans: 'Plans',
    profile: 'Profile',
    edit_profile: 'Edit Profile',
    notifications: 'Notifications',
    help: 'Help',
    payments: 'Payment Methods',
    settings: 'Settings',
    home: 'Devices',
    edit_device: 'Edit Device',
    not_authorized: 'Not Authorize',
    sso_success: 'SSO Login Successful',
    sso_fail: 'SSO Login Failed',
    admin: 'Administration',
  },
  offline: {
    headline: 'We\'ll be back shortly!',
    message: 'Our system is currently undergoing maintenance to provide you with an even better experience soon. Please check back later.',
  },
};

export default en;